<div
  class="compose-text-container"
  (click)="focus(false)"
  [ngClass]="{
    'highlighted-editor': isFocused,
    'private-background': replyingToThreadId,
    'linear-gradient-subtle-animated': isGeneratingAiResponse
  }"
>
  <div
    *ngIf="!isInlineEdit"
    style="padding: 4px 0 8px 0; margin-bottom: 2px"
    class="flex-space-between flexed-align-center"
  >
    <div style="overflow-x: clip; text-overflow: ellipsis">
      <span
        class="tab-nav-link"
        [ngClass]="{ 'tab-nav-active': !replyingToThreadId }"
        (click)="selectReplyTab()"
        *ngIf="!isDashboardBased"
      >
        <ion-icon [name]="replyingToThreadId ? 'arrow-undo-outline' : 'arrow-undo'"></ion-icon>
        Reply
      </span>
      <span class="tab-nav-link" [ngClass]="{ 'tab-nav-active': replyingToThreadId }" (click)="selectInternalNoteTab()">
        <ion-icon [name]="replyingToThreadId ? 'create' : 'create-outline'"></ion-icon>
        Internal note
      </span>
      <a
        (click)="showReplyOptions()"
        *ngIf="getInternalTriageMessages()?.length && replyingToThreadId"
        class="recipient-label"
      >
        {{ replyingToThreadLabel }}
        <ion-icon
          name="chevron-down-outline"
          class="button-icon"
          *ngIf="getInternalTriageMessages()?.length"
        ></ion-icon>
      </a>
      <a *ngIf="tos && tos.length && !replyingToThreadId" class="recipient-label hidden-sm" (click)="showTo()">
        to {{ tos[0].name }}
        <ion-icon [name]="isShowingTo ? 'chevron-up-outline' : 'chevron-down-outline'" class="button-icon"></ion-icon>
      </a>
    </div>
    <div *ngIf="isEmailBased && !replyingToThreadId" style="display: flex; align-items: center">
      <a style="font-weight: 400; margin: 0 4px" class="recipient-label" (click)="toggleCcShowing()">
        Cc
        <span *ngIf="ccs?.length" class="recipient-count">{{ ccs.length }} </span>
      </a>
      <a style="font-weight: 400; margin: 0 12px" class="recipient-label" (click)="toggleBccShowing()">
        Bcc
        <span *ngIf="bccs?.length" class="recipient-count">{{ bccs.length }} </span>
      </a>
    </div>
  </div>

  <ion-list
    lines="none"
    class="transparent-bg no-padding"
    *ngIf="(isEmailBased || isWidgetBased) && !replyingToThreadId && !isInlineEdit"
    #emailRecipientsWrapper
  >
    <ion-item [hidden]="!isShowingTo" style="border-bottom: 1px solid var(--ion-subtle-border-color)">
      <ion-label slot="start" style="margin: 0px; width: 40px">To</ion-label>
      <ion-chip
        mode="ios"
        class="btn-small tag-chip tag-chip-light"
        color="dark"
        *ngFor="let to of tos"
        (click)="changeTo()"
      >
        <ion-label>
          {{ to.email }}
        </ion-label>
      </ion-chip>
      <!-- Hack to get the layout to look good -->
      <ion-input readonly></ion-input>
    </ion-item>
    <ion-item [hidden]="!isShowingCc" style="border-bottom: 1px solid var(--ion-subtle-border-color)" text-wrap>
      <ion-label slot="start" style="margin: 0px; width: 40px">Cc</ion-label>
      <div class="cc-input-area">
        <ion-chip
          mode="ios"
          class="btn-small tag-chip tag-chip-light"
          color="dark"
          *ngFor="let cc of ccs; let i = index"
          (click)="deleteCc(i)"
          [disabled]="!cc.editable"
          [title]="cc.email"
        >
          <ion-label>
            {{ cc.email }}
            <ion-icon name="close-outline" style="font-size: 0.65rem"></ion-icon>
          </ion-label>
        </ion-chip>
        <ion-input
          #ccInput
          [(ngModel)]="ccText"
          placeholder="Add emails to cc and hit enter"
          (ionChange)="onCcChange()"
          (ionFocus)="onCcFocus()"
          (ionBlur)="onCcBlur()"
          (keydown)="onCcKeyDown($event)"
        ></ion-input>
      </div>
    </ion-item>
    <ion-item [hidden]="!isShowingBcc" style="border-bottom: 1px solid var(--ion-subtle-border-color)" text-wrap>
      <ion-label slot="start" style="margin: 0px; width: 40px">Bcc</ion-label>
      <div class="cc-input-area">
        <ion-chip
          mode="ios"
          class="btn-small tag-chip tag-chip-light"
          color="dark"
          *ngFor="let bcc of bccs; let i = index"
          (click)="deleteBcc(i)"
          [disabled]="!bcc.editable"
          [title]="bcc.email"
        >
          <ion-label>
            {{ bcc.email }}
            <ion-icon name="close-outline" style="font-size: 0.65rem"></ion-icon>
          </ion-label>
        </ion-chip>
        <ion-input
          #bccInput
          [(ngModel)]="bccText"
          placeholder="Add emails to bcc and hit enter"
          (ionChange)="onBccChange()"
          (ionFocus)="onBccFocus()"
          (ionBlur)="onBccBlur()"
          (keydown)="onBccKeyDown($event)"
        ></ion-input>
      </div>
    </ion-item>
  </ion-list>

  <div
    #editorWrapper
    class="editor"
    [ngxTippy]="editorTooltipTemplate"
    [tippyProps]="{
      trigger: 'manual',
      interactive: true,
      arrow: false
    }"
    tippyClassName="editor-tippy"
    [tippyName]="tippyName"
  ></div>

  <div *ngIf="templateHtml && !isInlineEdit" style="padding: 0 15px 12px" class="flex-space-between">
    <div style="width: 100%; border-right: 4px solid var(--ion-border-color); opacity: 0.6">
      <app-slack-message [content]="templateHtml"></app-slack-message>
    </div>
    <ion-button
      fill="clear"
      ngxTippy
      class="btn-small icon-button"
      (click)="messageBlocks = undefined; templateHtml = undefined"
      [tippyProps]="{
        touch: false,
        arrow: false,
        placement: 'top',
        content: 'Remove from message'
      }"
      ><ion-icon name="trash-outline"></ion-icon
    ></ion-button>
  </div>

  <ng-container *ngIf="showAttachments">
    <div
      *ngFor="let attachment of attachments; let i = index"
      style="padding: 0 15px 0; align-items: center"
      class="flex-space-between"
    >
      <div style="width: 100%" class="attachment">
        <ng-container *ngIf="!attachment.type.startsWith('image/')">{{ attachment.name }}</ng-container>
        <ng-container *ngIf="attachment.type.startsWith('image/')">
          <app-inline-file-attachment
            [conversationId]="conversation.id"
            [file]="attachment"
            [teamId]="conversation.slackChannel?.teamId"
            [size]="160"
          />
        </ng-container>
      </div>
      <ion-button
        fill="clear"
        ngxTippy
        class="btn-small"
        (click)="removeAttachment(i)"
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          content: 'Remove from message'
        }"
        ><ion-icon name="trash-outline"></ion-icon
      ></ion-button>
    </div>
  </ng-container>

  <div class="flex-space-between" style="padding: 0 0 4px; margin-top: -3px">
    <div style="padding: 0 8px">
      <ion-button
        class="btn-small send-attachment hidden-sm"
        (click)="insertMention()"
        fill="clear"
        color="dark"
        [hidden]="isEmailBased"
        [disabled]="isGeneratingAiResponse"
        ngxTippy
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          allowHTML: true,
          content: 'Mention someone<br/><small>Or type @ in the compose box</small>'
        }"
        style="font-size: 1rem"
      >
        &#64;
      </ion-button>
      <ion-button
        class="btn-small send-attachment"
        (click)="insertImage()"
        fill="clear"
        color="dark"
        [hidden]="!showAttachments"
        [disabled]="isGeneratingAiResponse"
        ngxTippy
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          content: 'Attach a file'
        }"
      >
        <ion-icon name="image-outline"></ion-icon>
      </ion-button>
      <ion-button
        class="btn-small send-attachment"
        (click)="insertTemplate()"
        fill="clear"
        color="dark"
        [disabled]="isGeneratingAiResponse"
        ngxTippy
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          content: 'Insert template'
        }"
      >
        <ion-icon name="shapes-outline"></ion-icon>
      </ion-button>
      <ion-button
        class="btn-small send-attachment hidden-sm"
        (click)="insertEmoji()"
        fill="clear"
        color="dark"
        [disabled]="isGeneratingAiResponse"
        ngxTippy
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          allowHTML: true,
          content: 'Add an emoji<br/><small>Or type : in the compose box</small>'
        }"
      >
        <ion-icon name="happy-outline"></ion-icon>
      </ion-button>
      <ion-button
        class="btn-small send-attachment hidden-sm"
        (click)="insertSlash()"
        fill="clear"
        color="dark"
        [disabled]="isGeneratingAiResponse"
        ngxTippy
        [tippyProps]="{
          touch: false,
          arrow: false,
          placement: 'top',
          content: 'Type / for additional commands'
        }"
      >
        <span
          style="border: 1px solid var(--ion-color-dark); border-radius: 4px; padding: 2.5px 5px; font-size: 0.5rem"
        >
          /
        </span>
      </ion-button>
    </div>
    <div *ngIf="showSendButton">
      <ng-container *ngIf="!isInlineEdit">
        <ion-button
          *ngIf="
            !isContentEmpty &&
            !isWidgetBased &&
            !isEmailBased &&
            !isMicrosoftTeamsBased &&
            !isDashboardBased &&
            !isBotDmBased &&
            !conversation.threadTs
          "
          fill="clear"
          class="icon-button btn-small send-attachment"
          color="dark"
          ngxTippy
          (click)="explainThreading()"
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'top',
            content: 'Replying will start a thread in Slack'
          }"
        >
          <ion-icon name="custom-blockquote"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="!isSendingReply && !hasUserChatWriteScope && !(repliesDisabled && !replyingToThreadId)"
          fill="clear"
          class="icon-button btn-small send-attachment"
          color="dark"
          (click)="connectUserToSlack()"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'top',
            content: 'Connect to Slack to enable additional features for this workspace'
          }"
        >
          <ion-icon name="information-circle-outline"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="repliesDisabled && !replyingToThreadId"
          fill="clear"
          class="icon-button btn-small send-attachment"
          color="danger"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'top',
            content: 'Replies are disabled for this conversation because it has been split into multiple conversations'
          }"
        >
          <ion-icon name="lock-closed-outline"></ion-icon>
        </ion-button>

        <ion-button
          *ngIf="isEmailBased && !replyingToThreadId && !isContentEmpty"
          class="btn-small"
          ngxTippy
          color="light"
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'top',
            content: 'Send a test email to yourself'
          }"
          (click)="sendReply(false, false, true)"
          [disabled]="isSendingReply || isGeneratingAiResponse"
        >
          <ion-icon name="mail-outline" style="font-size: 0.8rem; margin-right: 5px"></ion-icon>
          Test
        </ion-button>
        <ion-button
          class="btn-small send-button-left"
          ngxTippy
          [color]="isSendingReply || (isContentEmpty && !messageBlocks) ? 'light' : 'primary'"
          [tippyProps]="{
            touch: false,
            arrow: false,
            allowHTML: true,
            placement: 'top',
            content: sendButtonTooltipContent
          }"
          (click)="sendReply(false, false)"
          [disabled]="
            (isContentEmpty && !messageBlocks) ||
            isSendingReply ||
            (isDashboardBased && !replyingToThreadId) ||
            (repliesDisabled && !replyingToThreadId) ||
            isGeneratingAiResponse
          "
        >
          <ion-icon name="send" style="font-size: 0.8rem; margin-right: 5px"></ion-icon>
          Send
        </ion-button>
        <ion-button
          class="btn-small send-button-middle hidden-sm"
          ngxTippy
          [color]="isSendingReply || (isContentEmpty && !messageBlocks) ? 'light' : 'primary'"
          [tippyProps]="{
            touch: false,
            arrow: false,
            allowHTML: true,
            placement: 'top',
            content: sendAndSnoozeTooltipContent
          }"
          (click)="sendReply(true, false)"
          [disabled]="
            (isContentEmpty && !messageBlocks) ||
            isSendingReply ||
            (isDashboardBased && !replyingToThreadId) ||
            (repliesDisabled && !replyingToThreadId) ||
            isGeneratingAiResponse
          "
        >
          <ion-icon name="alarm-outline"></ion-icon>
        </ion-button>
        <ion-button
          class="btn-small send-button-right hidden-sm"
          ngxTippy
          [color]="isSendingReply || (isContentEmpty && !messageBlocks) ? 'light' : 'primary'"
          [tippyProps]="{
            touch: false,
            arrow: false,
            allowHTML: true,
            placement: 'top',
            content: sendAndCloseTooltipContent
          }"
          (click)="sendReply(false, true)"
          [disabled]="
            (isContentEmpty && !messageBlocks) ||
            isSendingReply ||
            (isDashboardBased && !replyingToThreadId) ||
            (repliesDisabled && !replyingToThreadId) ||
            isGeneratingAiResponse
          "
        >
          <ion-icon name="checkmark"></ion-icon>
        </ion-button>
        <ion-button
          class="btn-small send-button-right shown-sm"
          ngxTippy
          [color]="isSendingReply || (isContentEmpty && !messageBlocks) ? 'light' : 'primary'"
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'top',
            allowHTML: true,
            content: 'Send options'
          }"
          (click)="showSendOptions()"
          [disabled]="
            (isContentEmpty && !messageBlocks) ||
            isSendingReply ||
            (isDashboardBased && !replyingToThreadId) ||
            (repliesDisabled && !replyingToThreadId) ||
            isGeneratingAiResponse
          "
        >
          <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
        </ion-button>
      </ng-container>

      <ng-container *ngIf="isInlineEdit">
        <ion-button size="small" fill="clear" (click)="emitCancelEdit()" [disabled]="isSendingReply">
          Cancel
        </ion-button>
        <ion-button size="small" (click)="emitSaveEdit()" [disabled]="isSendingReply">
          <ion-spinner
            *ngIf="isSendingReply"
            name="crescent"
            slot="start"
            style="width: 1em; height: 1em"
          ></ion-spinner>
          Save
        </ion-button>
      </ng-container>
    </div>
  </div>
</div>

<div class="menu" style="visibility: hidden">
  <ion-button fill="clear" class="btn-small" (click)="addLink()" style="color: white">
    <ion-icon name="link-outline" style="margin-right: 3px"></ion-icon>
    Add link
  </ion-button>
  <ion-button fill="clear" class="btn-small" (click)="removeStyling()" style="color: white">
    <ion-icon name="close-outline" style="margin-right: 3px"></ion-icon>
    Remove formatting
  </ion-button>
</div>

<ng-template #editorTooltipTemplate>
  <ion-list class="transparent-bg" lines="none" *ngIf="autocompleteSearchMode === 'users'" class="tooltip-list">
    <ion-item
      *ngFor="let user of taggableUsers; let i = index"
      (click)="selectTaggedUser(user)"
      button="true"
      class="ion-item-rounded"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <app-avatar
        size="22"
        [style.height]="'22px'"
        [style.width]="'22px'"
        [style.margin]="'0 5px 0 -5px'"
        slot="start"
        [name]="user.name"
        [image]="user.image"
      >
      </app-avatar>
      <ion-label>
        {{ user.name }}
        <p *ngIf="isEmailBased">
          {{ user.email }}
        </p>
      </ion-label>
    </ion-item>

    <div class="flexed-align-center" *ngIf="!taggableUsers">
      <ion-skeleton-text animated style="width: 22px; height: 22px; border-radius: 50%; margin-right: 5px"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 182px; height: 16px; border-radius: 4px; margin-right: 5px"></ion-skeleton-text>
    </div>

    <ion-item *ngIf="taggableUsers && !taggableUsers?.length"> No users found </ion-item>
  </ion-list>

  <ion-list class="transparent-bg" lines="none" *ngIf="autocompleteSearchMode === 'emojis'">
    <ion-item
      *ngFor="let emoji of emojisList; let i = index"
      button="true"
      (click)="selectEmoji(emoji)"
      class="ion-item-rounded"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-label style="display: flex; align-items: center; margin: 2px">
        <span style="font-size: 1.6rem; margin-right: 6px">{{ emoji.skins[0].native }}</span> {{ emoji.id }}</ion-label
      >
    </ion-item>
  </ion-list>

  <ion-list class="transparent-bg" lines="none" *ngIf="autocompleteSearchMode === 'slash'">
    <span style="opacity: 0.7; margin-left: 8px; font-size: 0.8rem">Insert</span>
    <ion-item
      *ngFor="let command of slashCommands; let i = index"
      button="true"
      class="ion-item-rounded"
      (click)="selectSlashCommand(command)"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-icon [name]="command.icon" style="margin-right: 8px; font-size: 1.2rem"></ion-icon>
      <ion-label style="margin: 8px 0">
        {{ command.title }}
        <p>
          {{ command.description }}
        </p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="!slashCommands?.length">
      <ion-label> No command found </ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="transparent-bg" lines="none" *ngIf="autocompleteSearchMode === 'articles'" class="tooltip-list">
    <ion-item
      *ngFor="let article of articles; let i = index"
      button="true"
      class="ion-item-rounded"
      (click)="selectArticle(article)"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-label>
        {{ article.title }}
        <p>
          {{ article.description }}
        </p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="!articles?.length">
      <ion-label> No article found </ion-label>
    </ion-item>
  </ion-list>

  <ion-list class="transparent-bg" lines="none" *ngIf="autocompleteSearchMode === 'automations'" class="tooltip-list">
    <ion-item
      *ngFor="let automation of automations; let i = index"
      button="true"
      class="ion-item-rounded"
      (click)="runAutomation(automation)"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-label>
        {{ automation.name }}
        <p>
          {{ automation.description }}
        </p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="!automations?.length">
      <ion-label> No automation found </ion-label>
    </ion-item>
  </ion-list>
</ng-template>
